// 高级搜索组件slot所需自定义特殊组件
export default {
  install: (Vue, options) => {
    Vue.component("el-year-range", {
      props: {
        name: {
          type: String
        },
        value: {
          type: Array
        }
      },
      data() {
        return {
          startTime: "",
          endTime: ""
        };
      },
      watch: {
        value(newValue) {
          this.startTime = newValue[0];
          this.endTime = newValue[1];
        }
      },
      methods: {
        handleChange() {
          let startTime = this.startTime;
          let endTime = this.endTime;
          if (startTime && endTime) {
            startTime > endTime &&
              ([this.startTime, this.endTime] = [endTime, startTime]);
          }
          if (!startTime && !endTime) {
            return this.$emit("input", []);
          }
          if (this.endTime && this.endTime.includes("01-01")) {
            this.endTime = this.endTime.replace("01-01", "12-31");
          }
          this.$emit("input", [this.startTime, this.endTime]);
        }
      },
      template: `
        <div class="ccui-price-range" style="display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    padding: 0 10px;
    width: 260px;">
        <el-date-picker
            class="mr8"
            v-model="startTime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            @change="handleChange"
            style="width:50%;margin-right: 5px"
            type="year"
        />
        <span>至</span>
        <el-date-picker
            class="mr8"
            v-model="endTime"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            style="width:50%;margin-left: 5px"
            @change="handleChange"
            key="year"
            type="year"
        />
        </div>
      `
    });
  }
};
